export default __webpack_public_path__ + "static/media/IMG-20241210-WA0029.2de7005a.jpg";